import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const mainContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  borderBottom: `1px solid ${greys.cloudyBlue}`,
};

export const pouroverContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "0 5px 5px",
  minWidth: 58,
};

export const eventsContainer: CSSProperties = {
  width: "100%",
  paddingTop: 5,
};

export const eventContainer: CSSProperties = {
  position: "relative",
  marginRight: 20,
};

export const pouroverTypography: CSSProperties = {
  cursor: "pointer",
  paddingLeft: 10,
  paddingBottom: 5,
};

export const styles = {
  mainContainer,
  pouroverContainer,
  eventContainer,
  eventsContainer,
  pouroverTypography,
};
